
// 自定义3d柱状图、及其工具函数使用
export default {
  methods: {
    // 引入自定义图形处理方式
    getCustomSeries(options) {
      // 增加扩展参数的方法
      const commonExtension = [['singleData', []]];
      const barbubbleExtension = [['isBottomCircle', false], ['isBaseValue', false], ['baseValue', 20], ['symbolSize', 20]];
      options.forEach(it => {
        let extensionMap = commonExtension.concat([]);
        switch (it.shape) {
          case 'barbubble':
            extensionMap = extensionMap.concat(barbubbleExtension);
            break;
          default:
            break;
        }
        extensionMap.forEach(item => {
          const [key, value] = item;
          if (it[key] === undefined) {
            it[key] = value;
          }
        })
        if (it.shape === 'rect') {
          it.type = 'bar';
        } else if (it.shape) {
          it.type = 'custom';
        }
      })
      // total，需要被纳入中心点计算的图形
      const [total, barGap, widths] = options.reduce((before, item) => {
        let [count, distance, widths] = before;
        if (item.type === 'custom') {
          return [count + 1, item.barGap, [...widths, this.getStringToNumber(item.barWidth)]];
        }
        return [count, distance, widths];
      }, [0, 0, []])
      let count = 0;
      return options.reduce((arr, item, idx) => {
        // 总数
        item.total = total;
        item.curIdx = idx - count;
        item.widths = widths;
        item.seriesWidth = this.getStringToNumber(item.barWidth);
        item.distance = this.getStringToNumber(barGap);
        let new_series = item;
        switch (item.shape) {
          case 'clinder':
            new_series = this.getClinder(item);
            break;
          case 'cube':
            new_series = this.getCube(item);
            break;
          case 'barbubble':
            new_series = this.getBarBuble(item);
            break;
          case 'rect':
            new_series = this.getBarRect(item);
            break;
          case 'cone':
            new_series = this.getCone(item);
            break;
          default:
            break;
        }
        if (!item.shape) {
          count++;
        }
        arr.push(new_series);
        return arr;
      }, [])
    },
    getDefaultLineproperty(type) {
      // 构造折线需要的属性
      const lineSeries = {
        type: 'line',
        name: '',
        //对应x轴下标
        yAxisIndex: 0,
        //对应y轴下标
        xAxisIndex: 0,
        // 标记图形
        symbol: 'emptyCircle',
        //标记大小
        symbolSize: 4,
        //是否展示标记
        showSymbol: false,
        //标签是否展示
        label: {
          show: false,
          color: '#fff',
          position: 'top',
          fontSize: 12
        },
        //是否平滑
        smooth: true,
        // 区域颜色
        areaStyle: {
          color: 'rgba(255,255,255,0)',
          endColor: 'rgba(255,255,255,0)',
          startColor: 'rgba(255,255,255,0)',
          isshade: false
        },
        // 线条样式
        itemStyle: {
          color: '#5470c6',
          endColor: '#5470c6',
          startColor: '#5470c6',
          isshade: false
        },
        lineStyle: {
          width: 2,
          type: 'solid'
        },
        //数据名称映射
        nameRelation: '',
        //数据值映射
        valueRelation: '',
        //数据
        data: [820, 932, 901, 934, 1290, 1330, 1320],
        z: 20,
        zlevel: 20
      };
      const customSeris = {
        type: 'custom',
        name: '',
        //对应x轴下标
        yAxisIndex: 0,
        shape: 'clinder', // clinder 圆柱， cube 立方体
        //对应y轴下标
        xAxisIndex: 0,
        //标签是否展示
        label: {
          show: false,
          color: '#fff',
          position: 'inside',
          fontSize: 12
        },
        barGap: '5',
        // 柱体样式
        itemStyle: {
          color: '#5470c6',
          // 柱体圆角
          borderRadius: [0, 0, 0, 0],
          endColor: '#0048CB',
          startColor: '#0EC3FF',
          isshade: true,
          // 3d柱状图颜色
          cubeColors: [['rgba(168,255,255,1)', 'rgba(238,255,255,1)'], ['rgba(78,220,220,1)', 'rgba(193,250,250,1)'], ['rgba(219,255,255,1)', 'rgba(223,255,255,1)']],
        },
        // 柱体宽度
        barWidth: 20,
        //柱子背景色
        showBackground: false,
        //数据名称映射
        nameRelation: '',
        //数据值映射
        valueRelation: '',
        renderItem: null,
        //数据
        data: [888, 932, 901, 934, 1290, 1330, 1320],
      }
      switch (type) {
        case 'line':
          return lineSeries;
        default:
          return customSeris;
      }
    },
    // 圆柱参数处理
    getClinder(item) {
      const shadeColor = {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 1, color: item.itemStyle.endColor // 0% 处的颜色
        }, {
          offset: 0, color: item.itemStyle.startColor // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }
      // 切换为圆柱需要改成的属性
      item.shape = 'clinder';
      // 清除原有的绘制函数
      item.renderItem = null;
      item.itemStyle.color = shadeColor;
      return this.dimensionalSeries(item);
    },
    // 正方体参数处理
    getCube(item) {
      // 切换为正方体属性
      item.shape = 'cube';
      // 清除原有的绘制函数
      item.renderItem = null;
      // 构造colors, seriesLabel, seriesName, seriesWidth
      const cubeColor = item.itemStyle.cubeColors;
      item.colors = cubeColor;
      item.itemStyle.color = {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 1, color: cubeColor[0][0] // 0% 处的颜色
        }, {
          offset: 0, color: cubeColor[0][1] // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }
      // echarts因为在此时已经注册在全局，因此可以使用
      return this.cubeSeries(item, echarts);
    },
    getCone(item) {
      const shadeColor = {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 1, color: item.itemStyle.endColor // 0% 处的颜色
        }, {
          offset: 0, color: item.itemStyle.startColor // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }
      // 切换为圆柱需要改成的属性
      item.shape = 'cone';
      // 清除原有的绘制函数
      item.renderItem = null;
      item.itemStyle.color = shadeColor;
      return this.coneBarSeries(item);
    },
    // 柱泡图参数处理
    getBarBuble(item) {
      // 切换为柱泡图属性
      item.shape = 'barbubble';
      // 清除原有的绘制函数
      item.renderItem = null;
      return this.barBubleSeries(item, echarts);
    },
    // 正方形参数处理
    getBarRect(item) {
      // 切换为正方形属性
      const { singleData = [], itemStyle } = item;
      item.shape = 'rect';
      item.type = 'bar';
      let color = null;
      if (item.isshade) {
        color = {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 1,
              color: itemStyle.startColor, // 0% 处的颜色
            },
            {
              offset: 0,
              color: itemStyle.endColor, // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        }
      }
      item.data = item.data.map((item, idx) => {
        if (!item) return null;
        let renderColor = null;
        if (singleData[idx]) {
          const singleItem = _.cloneDeep(singleData[idx].itemStyle);
          renderColor = singleItem.color;
        }
        if (!renderColor) {
          return item.value || item;
        }
        const itemStyle = item.itemStyle ? item.itemStyle : {};
        return {
          value: item.value || item,
          itemStyle: {
            ...itemStyle,
            color: renderColor
          }
        }
      })
      // 清除原有的绘制函数
      item.renderItem = null;
      return item;
    },
    // 获取中心点函数，长度， 相差的距离，实际的像素点, 宽度
    getOffsetDistance(widths, point, distance, total) {
      // 中心点像素点： point
      // 柱子之间的距离: distance
      // 柱子的宽度：widths
      // 总数： total
      const isOdd = total % 2 === 0, mid = Math.floor(total / 2);
      const offsetMap = [];
      // 加上间距
      widths = widths.map(item => item + 0.5 * distance);

      function distanceNotOdd(idx, mid, widths, point) {
        // 当前柱子是中心点
        if (idx === mid) {
          return 0;
        }
        const map = idx < mid ? widths.slice(idx, mid + 1) : widths.slice(mid);
        const count = map.reduce((count, item, index) => {
          if (index === 0 || index === map.length - 1) {
            return count + 0.5 * item;
          }
          return count + item;
        }, 0);
        return idx < mid ? point - count : point + count;
      }
      function distanceIsOdd(idx, mid, widths, point) {
        // 当前柱子是中心点
        if (idx === mid || idx === mid - 1) {
          return idx - mid < 0 ? point - 0.5 * widths[idx] : point + 0.5 * widths[idx];
        }
        const map = idx < mid ? widths.slice(idx, mid) : widths.slice(mid);
        const count = map.reduce((count, item, index) => {
          if (idx < mid && index === 0) {
            return count + 0.5 * item;
          }
          if (idx > mid && index === map.length - 1) {
            return count + 0.5 * item;
          }
          return count + item;
        }, 0);
        return idx < mid ? point - count : point + count;
      }

      for (let i = 0; i < total; i++) {
        if (isOdd) {
          // 偶数情况下计算方式
          offsetMap.push(distanceIsOdd(i, mid, widths, point));
        } else {
          // 奇数情况下计算方式
          offsetMap.push(distanceNotOdd(i, mid, widths, point));
        }
      }
      return offsetMap;
    },
    // 自定义正方体
    cubeSeries(item, echarts) {
      // 绘制左侧面
      const CubeLeft = (echarts, drawMap) =>
        echarts.graphic.extendShape({
          shape: {
            x: 0,
            y: 0,
          },
          buildPath: function (ctx, shape) {
            // 当前柱子x,y 数据顶点。xAxisPoint当前柱子数据底部点
            const { xAxisPoint, x, y, yValue } = shape;
            const { width } = drawMap;
            if (!width) {
              return
            }
            // 计算distance
            const distance = (+(width / 2).toFixed(1));
            const c0 = [x + distance, y]; // 右上角点
            const c1 = [x - distance, y]; // 左上角点
            const c2 = [xAxisPoint[0] - distance, xAxisPoint[1]]; // 右下角点
            const c3 = [xAxisPoint[0] + distance, xAxisPoint[1]]; // 左下角点
            ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).closePath();
          },
        })

      // 绘制右侧面
      const CubeRight = (echarts, drawMap) =>
        echarts.graphic.extendShape({
          shape: {
            x: 0,
            y: 0,
          },
          buildPath: function (ctx, shape) {
            const { xAxisPoint, x, y, yValue } = shape;
            const { width, offsetY, offsetX, point } = drawMap;
            if (!width) {
              return
            }
            // 计算distance
            // 偏移采用 3
            // offsetY = 8, offsetX = 6
            // point = 0.5
            const distance = (+(width / 2).toFixed(1));
            // 矩形盒子采用4 ：3的比例
            let c1 = [x + distance - point, y] // 左上
            let c2 = [x + distance + offsetX, y - offsetY] // 右上 
            let c3 = [xAxisPoint[0] + distance + offsetX, xAxisPoint[1] - offsetY] // 右下
            let c4 = [xAxisPoint[0] + distance - point, xAxisPoint[1]] // 左下
            if (yValue < 0) {
              c1 = [x + distance + Number(point), xAxisPoint[1]] // 左上
              c2 = [x + distance + offsetX, xAxisPoint[1] + Number(offsetY)] // 右上
              c3 = [xAxisPoint[0] + distance + offsetX, Number(y) + Number(offsetY)] // 右下
              c4 = [xAxisPoint[0] + distance - point, y] // 左下
            }
            ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
          },
        })

      // 绘制顶面
      const CubeTop = (echarts, drawMap) =>
        echarts.graphic.extendShape({
          shape: {
            x: 0,
            y: 0,
          },
          buildPath: function (ctx, shape) {
            // 当前柱子x,y 数据顶点。xAxisPoint当前柱子数据底部点
            const { x, y, yValue } = shape;
            const { width, offsetY, offsetX, point } = drawMap;
            if (!width) {
              return
            }
            // 计算distance
            // offsetY = 8, offsetX = 6, point = 0.5
            const distance = (+(width / 2).toFixed(1));
            // 矩形盒子采用4 ：3的比例
            const c1 = [x - distance, Number(y) + point]; // 左下点 
            const c2 = [x + distance, Number(y) + point]; // 右下点
            let c3 = [x + distance + offsetX, y - offsetY]; // 右上
            let c4 = [x - distance + offsetX, y - offsetY]; // 左上
            if (yValue < 0) {
              c3 = [x + distance + offsetX, Number(y) + offsetY];
              c4 = [x - distance + offsetX, Number(y) + offsetY];
            }
            ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
          },
        })

      let { data, yAxisIndex, seriesWidth, label, total, curIdx, distance, colors, widths, singleData = [] } = item;
      colors = colors.map((item) => ({
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 1, color: item[0] // 0% 处的颜色
        }, {
          offset: 0, color: item[1] // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }))
      const width = (+seriesWidth);
      // 处理绘制参数
      const drawMap = {
        width,
        offsetY: (Math.floor(width / 5) - 4) + 8, // 按照8作为基准值进行比例判断
        offsetX: ((Math.floor(width / 5) - 4) + 8) * 3 / 4, // 按照3：4的比例模型
        point: width > 20 ? 0.5 : (Math.floor(width / 5) * 0.1) + 0.1 // 像素差的计算方式
      }
      echarts.graphic.registerShape('CubeLeft', CubeLeft(echarts, drawMap));
      echarts.graphic.registerShape('CubeRight', CubeRight(echarts, drawMap));
      echarts.graphic.registerShape('CubeTop', CubeTop(echarts, drawMap));
      return {
        ...item,
        label: {
          ...label,
          offset: label.position === 'top' ? [drawMap.offsetX, -(drawMap.offsetY / 2)] : 0,
        },
        renderItem: (params, api) => {
          const index = params.dataIndex;
          let singleColor = null;
          if (singleData[index]) {
            const singleItem = singleData[index].itemStyle.cubeColors;
            singleColor = singleItem.map((item) => ({
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 1, color: item[0] // 0% 处的颜色
              }, {
                offset: 0, color: item[1] // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }))
          }
          const [x, y] = api.coord([api.value(0), api.value(1)])
          const [bx, by] = api.coord([api.value(0), 0])
          // widths, point, distance, total
          const cache = this.getOffsetDistance(widths, x, distance, total);
          const fact_x = cache[curIdx] || x;
          const rel_colors = singleColor ? singleColor : colors;
          return {
            type: 'group',
            enterFrom: {
              y: by,
              opacity: 0,
              scaleY: 0,
            },
            children: [
              {
                type: 'CubeLeft',
                z2: 2,
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: fact_x,
                  y: y.toFixed(1),
                  xAxisPoint: [fact_x, api.coord([api.value(0), 0])[1]],
                },
                style: api.style({
                  fill: rel_colors[0],
                })
              },
              {
                type: 'CubeRight',
                z2: 0,
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: fact_x,
                  y: y.toFixed(1),
                  xAxisPoint: [fact_x, api.coord([api.value(0), 0])[1]],
                },
                style: api.style({
                  fill: rel_colors[1],
                  text: ''
                })
              },
              {
                type: 'CubeTop',
                z2: 0,
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: fact_x,
                  y: y.toFixed(1),
                  xAxisPoint: [fact_x, api.coord([api.value(0), 0])[1]],
                },
                style: api.style({
                  fill: rel_colors[2],
                  text: ''
                })
              },
            ]
          }
        },
        data: data,
        silent: true,
        zlevel: 0,
        yAxisIndex,
      }
    },
    // 自定义圆柱
    dimensionalSeries(item) {
      let { data, yAxisIndex, seriesWidth, label, total, curIdx, distance, widths, singleData = [] } = item;
      return {
        ...item,
        label: {
          ...label,
        },
        renderItem: (params, api) => {
          const index = params.dataIndex;
          let singleColor = null;
          if (singleData[index]) {
            const singleItem = singleData[index].itemStyle;
            singleColor = {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 1, color: singleItem.startColor // 0% 处的颜色
              }, {
                offset: 0, color: singleItem.endColor // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          }
          const [x, y] = api.coord([api.value(0), api.value(1)]);
          const colors = singleColor ? singleColor : api.style().fill;
          const [bx, by] = api.coord([api.value(0), 0]);
          let width = seriesWidth / 2;
          const cache = this.getOffsetDistance(widths, x, distance, total);
          const fact_x = cache[curIdx] || x;
          if (!api.value(1)) {
            width = 0;
          }
          return {
            type: 'group',
            enterFrom: {
              y: by,
              opacity: 0,
              scaleY: 0,
            },
            children: [
              {
                type: 'circle',
                scale: [1, 0.4],
                origin: [fact_x, by],
                z2: 2,
                shape: {
                  cx: fact_x,
                  cy: by,
                  r: width,
                  // r0: 30,
                },
                style: api.style({
                  fill: colors,
                  text: ''
                })
              },
              {
                type: 'circle',
                scale: [1, 0.4],
                origin: [fact_x, y],
                z2: 2,
                shape: {
                  cx: fact_x,
                  cy: y,
                  r: width,
                  // r0: 30,
                },
                style: api.style({
                  fill: colors,
                  text: ''
                })
              },
              {
                type: 'rect',
                origin: [fact_x, y],
                shape: {
                  x: fact_x - width,
                  y: api.value(1) > 0 ? y : by,
                  width: 2 * width,
                  height: Math.abs(y - by)
                  // r0: 30,
                },
                style: api.style({
                  fill: colors,
                })
              },
            ]
          }
        },
        data: data,
        // silent: true,
        // zlevel: 0,
        yAxisIndex,
      }
    },
    // 自定义圆锥
    coneBarSeries(item) {
      let { data, yAxisIndex, seriesWidth, label, total, curIdx, distance, widths, singleData = [] } = item;
      return {
        ...item,
        label: {
          ...label,
        },
        renderItem: (params, api) => {
          const index = params.dataIndex;
          let singleColor = null;
          if (singleData[index]) {
            const singleItem = singleData[index].itemStyle;
            singleColor = {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 1, color: singleItem.startColor // 0% 处的颜色
              }, {
                offset: 0, color: singleItem.endColor // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          }
          const [x, y] = api.coord([api.value(0), api.value(1)]);
          const colors = singleColor ? singleColor : api.style().fill;
          const [bx, by] = api.coord([api.value(0), 0]);
          let width = seriesWidth / 2;
          const cache = this.getOffsetDistance(widths, x, distance, total);
          const fact_x = cache[curIdx] || x;
          if (!api.value(1)) {
            width = 0;
          }
          // 多边形点集合
          const points = [[fact_x, y], [fact_x - width, by], [fact_x + width, by]];
          return {
            type: 'group',
            enterFrom: {
              y: by,
              opacity: 0,
              scaleY: 0,
            },
            // leaveTo: {
            //   y: y,
            //   opacity: 0,
            // },
            transition: 'shape',
            children: [
              {
                type: 'polygon',
                // y: y,
                origin: [fact_x, y],
                z2: 2,
                shape: {
                  points
                  // r0: 30,
                },
                style: api.style({
                  fill: colors,
                  text: ''
                })
              },
              {
                type: 'circle',
                scale: [1, 0.4],
                origin: [fact_x, by],
                z2: 2,
                shape: {
                  cx: fact_x,
                  cy: by,
                  r: width,
                  // r0: 30,
                },
                style: api.style({
                  fill: colors,
                  text: ''
                })
              },
            ]
          }
        },
        data: data,
        // silent: true,
        // zlevel: 0,
        yAxisIndex,
      }
    },
    // 自定义柱泡图
    barBubleSeries(item) {
      let { data, yAxisIndex, seriesWidth, label, total, curIdx, distance, widths, baseValue = 20, isBottomCircle = false, isBaseValue = false, symbolSize = 20, singleData = [] } = item;
      const sizeData = this.caculateBaseSereisSize(data, baseValue);
      return {
        ...item,
        label: {
          ...label,
        },
        renderItem: (params, api) => {
          const index = params.dataIndex;
          let singleColor = null;
          if (singleData[index]) {
            const singleItem = _.cloneDeep(singleData[index].itemStyle);
            singleColor = singleItem.color;
          }
          const colors = singleColor ? singleColor : api.style().fill;
          const [x, y] = api.coord([api.value(0), api.value(1)]);
          const [bx, by] = api.coord([api.value(0), 0]);
          let width = seriesWidth / 2;
          let circleWidth = isBaseValue ? sizeData[index] : symbolSize;
          const cache = this.getOffsetDistance(widths, x, distance, total);
          const fact_x = cache[curIdx] || x;
          const circlePosition = isBottomCircle ? [fact_x, by] : [fact_x, y];
          if (!api.value(1)) {
            width = 0;
            circleWidth = 0;
          }
          return {
            type: 'group',
            enterFrom: {
              y: by,
              opacity: 0,
              scaleY: 0,
            },
            children: [
              {
                type: 'circle',
                origin: circlePosition,
                z2: 2,
                shape: {
                  cx: fact_x,
                  cy: isBottomCircle ? by : y,
                  r: circleWidth,
                  // r0: 30,
                },
                style: api.style({
                  fill: colors,
                  text: ''
                })
              },
              {
                type: 'rect',
                origin: [fact_x, y],
                shape: {
                  x: fact_x - width,
                  y: api.value(1) > 0 ? y : by,
                  width: 2 * width,
                  height: Math.abs(y - by)
                  // r0: 30,
                },
                style: api.style({
                  fill: colors,
                })
              },
            ]
          }
        },
        data: data,
        yAxisIndex,
      }
    },
    // color当前颜色，idx需要当前组
    smallColor(color, idx) {
      const start = tinycolor(color).toRgb();
      let count = 0;
      const result = [];
      while (count < idx) {
        count++;
        const temp = []
        for (let i = 0; i < 2; i++) {
          const params = {
            r: Math.round(start.r - (start.r) * Math.random()),
            g: Math.round(start.g - (start.g) * Math.random()),
            b: Math.round(start.b - (start.b) * Math.random()),
          };
          temp.push(tinycolor(params).desaturate(count * 10).toHexString());
        }
        result.push(temp);
      }
      return idx === 1 ? result[0] : result;
    },
    // 计算数据大小
    caculateBaseSereisSize(data, baseValue) {
      // 计算大小时注意负数
      const max_value = data.reduce((max, it) => {
        if (dsf.isUnDef(it)) {
          return max;
        }
        const value = Math.abs(it.value || it);
        return Math.max(max, this.getStringToNumber(Math.abs(value)));
      }, 0);
      return data.map(it => {
        if (dsf.isUnDef(it)) {
          return 0;
        }
        const value = Math.abs(it.value || it);
        return Math.round((value / max_value) * baseValue);
      })
    },
    getStringToNumber(string) {
      let value = parseFloat(string);
      if (isNaN(value)) {
        value = 0;
      }
      return value < 0 ? 2 * value : value;
    },
  }
}
